import React, { Component } from "react";
import LoginForm from "../../../components/auth/LoginForm";
import { connect } from "react-redux";
import { requestTokens } from "../../../store/iam/operations";
import loginValidators from "./validators";
import { navigate } from "../../../store/navigation/operations";
import ReactGA from "react-ga";

export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGoToRegister = this.handleGoToRegister.bind(this);
  }

  handleSubmit(user_name, password) {
    ReactGA.event({
      category: "User",
      action: "Logged in"
    });
    this.props.requestTokens(user_name.toLowerCase(), password, this.props.redirectTo).then(() => {
      if (this.props.onAuthCallback) {
        this.props.onAuthCallback();
      }
    });
  }
  handleGoToRegister() {
    if (this.props.onRegisterClick) {
      this.props.onRegisterClick();
    } else {
      this.props.navigate("/sign-up");
    }
  }
  render() {
    return (
      <div>
        <LoginForm
          isOpen={this.props.isOpen}
          onClose={this.props.onClose}
          onLogin={this.handleSubmit}
          validators={loginValidators}
          isLoading={this.props.loading}
          goToRegister={this.handleGoToRegister}
          onRecoverPassword={() => {
            this.props.navigate("/recover-password");
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  loading: state.iam.loading
});
const mapDispatchToProps = dispatch => ({
  navigate: to => {
    return dispatch(navigate(to));
  },
  requestTokens: (user_name, password, redirectTo) => {
    return dispatch(requestTokens(user_name, password, redirectTo));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
